import { DefaultLayout } from "../layouts";

import UserDashboard from "../../src/pages/UserPages/Dashboard/UserDashboard";
import UserOrganizations from "../pages/UserPages/UserOrganizations/UserOrganizations";
import ViewOrganization from "../pages/Organization/ViewOrganization";
import UserDataElements from "../pages/UserPages/UserDataElements";
import UserDataEntries from "../pages/UserPages/UserDataEntries";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "../pages/AboutUs/AboutUs";
import Setting from "../pages/Settings/Setting";
import { Updateaccountdetails } from "../pages/Acount/Updateaccountdetails";

export const GlobalUserRoutes = [
  // {
  //   path: "/",
  //   exact: true,
  //   layout: DefaultLayout,
  //   component: () => <Navigate to="/dashboard" />,
  // },
  {
    path: "/dashboard",
    exact: true,
    layout: DefaultLayout,
    component: UserDashboard,
  },
  {
    path: "/organizations",
    exact: true,
    layout: DefaultLayout,
    component: UserOrganizations,
  },
  {
    path: "/data-elements",
    exact: true,
    layout: DefaultLayout,
    component: UserDataElements,
  },
  {
    path: "/data-entry",
    exact: true,
    layout: DefaultLayout,
    component: UserDataEntries,
  },
  {
    path: "/view-organization/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewOrganization,
  },
  {
    path: "/privacy",
    exact: true,
    layout: DefaultLayout,
    component: PrivacyPolicy,
  },
  {
    path: "/terms-and-conditions",
    exact: true,
    layout: DefaultLayout,
    component: AboutUs,
  },

  {
    path: "/settings",
    exact: true,
    layout: DefaultLayout,
    component: Setting,
  },
  {
    path: "/profile",
    exact: true,
    layout: DefaultLayout,
    component: Updateaccountdetails,
  },
];
